import { RouteReversedDtoModelType } from '../../models';
import getAppRoot from '../../utils/getAppRoot';
import RouteOverviewQuery from '../../queries/routes/RouteOverviewQuery';

export default ({ route, store }: RouteReversedDtoModelType) => () => {
  const rootStore = getAppRoot(store);
  const projectId = rootStore.ui.selectedWorkspace?.id;
  const routeId = rootStore.ui.selectedRoute?.id;

  if (projectId != null) {
    if (routeId != null && routeId === route?.id) {
      store.queryRouteById({ projectId, routeId }, RouteOverviewQuery);
    }
  }
};
